import actions from "./actions";

export default function attributesReducers(state = [], action: {payload:any, type: string}):any{
    switch (action.type) {
        case actions.SET_DATA:
            return [...action.payload];
        case actions.SET_INITIAL_ATTRIBUTES:
            return []
        default:
            return state
    }
}